import { render, staticRenderFns } from "./TablesList.vue?vue&type=template&id=6cf016f0&scoped=true&"
import script from "./TablesList.vue?vue&type=script&lang=js&"
export * from "./TablesList.vue?vue&type=script&lang=js&"
import style0 from "./TablesList.vue?vue&type=style&index=0&id=6cf016f0&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf016f0",
  null
  
)

export default component.exports